<!--
 * @Description: 3行两列通用弹窗标牌
-->
<template>
  <div class="common_panel" :style="{ height: 170 + leftList.length * 75 + 'px' }">
    <div class="common_panel_header">
      <div class="title">{{ title }}</div>
      <div class="close" @click="onClose"></div>
    </div>

    <div class="common_panel_body">
      <div class="body_left" :style="{ height: leftList.length * 75 + 'px' }">
        <div :title="item" class="leftItem" v-for="(item, index) in leftList" :key="'leftList' + index">{{ item }}</div>
      </div>
      <div class="body_right" :style="{ height: leftList.length * 75 + 'px' }">
        <div :title="item" class="rightItem" v-for="(item, index) in rightList" :key="'rightList' + index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PublicPanel',
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    console.log(this.info);
    this.title = this.landmarkLayerIdObj.scatterType;
    let name = this.landmarkLayerIdObj.name;
    switch (this.landmarkLayerIdObj.scatterType) {
      case 'GantryCrane':
        this.leftList = ['NO', 'Type', 'Area', 'Status', 'Work Type'];
        this.rightList = ['RB01', 'Remote', '5-1', 'Working', 'Loading'];
        break;
      case 'Container':
        this.title = 'Container Information';
        this.leftList = [
          'NO',
          'Type',
          'Size',
          'Box Weight',
          'Storage Area',
          'Transport Ship',
          'Flight in',
          'Flight out',
          'Import or Export'
        ];
        this.rightList = ['MK124D21', 'Universal', '20', '25873KG', '6-1', 'Titanic', '01A', '58B', 'Import'];
        break;
      case 'BridgeCrane':
        this.leftList = ['NO', 'Type', 'Status', 'Work Type', 'Work Ship'];
        this.rightList = ['A1241', 'Remote', 'Working', 'Unload', 'Titanic'];
        break;
      default:
        this.leftList = ['', '', ''];
        break;
    }
  },
  destroyed() {},
  data() {
    return {
      leftList: ['仓储位置', '实验室样品数', '实验室耗材数', '统计时间'],
      rightList: ['4楼B428', '10个', '10个', '2022年7月8日'],
      title: '标牌名称'
    };
  },
  computed: {
    ...mapState(['prevModelLayer', 'landmarkLayerIdObj'])
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    }
  }
};
</script>

<style lang="less" scoped>
.common_panel {
  transform: scale(1);
  transform-origin: center bottom;
  pointer-events: all;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 860px;

  min-height: 84px;
  line-height: 70px;
  background: rgba(0, 0, 0, 0.5);
  background-image: url('./Img/PublicPanel.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 32px;
  color: #fff;
  font-family: 'Helvetica';
  .close {
    pointer-events: all;
    width: 18px;
    height: 18px;
    // background: url('../../assets/img/GisPanel/close.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: -14px;
    right: 10px;
  }
  .titys {
    position: absolute;
    left: 90px;
    top: 5px;
  }
  .common_panel_header {
    display: flex;
    position: relative;
    justify-content: space-between;
    box-sizing: border-box;
    height: 26px;
    padding: 0 13px;
    top: 8px;
    .title {
      font-family: 'Helvetica';
      font-size: 48px;
      color: #ffffff;
      position: absolute;
      margin-left: 20px;
      margin-top: 10px;
      text-align: start;
      width: 600px;
    }
    .close {
      width: 48px;
      height: 49px;
      background: url('./Img/close.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 15px;
      right: 35px;
    }
  }
  .common_panel_body {
    width: 697px;

    display: flex;
    justify-content: space-between;

    font-size: 16px;
    margin: 0px auto;
    margin-top: 92px;
    .body_left {
      height: 100%;
      width: 314px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #bfebff;
      line-height: 24px;
      .leftItem {
        width: 100%;
        height: 74px;
        background: #00000035;
        display: flex;
        font-family: 'Helvetica';
        font-size: 36px;
        box-sizing: border-box;
        padding-left: 15px;
        line-height: 80px;
      }
    }
    .body_right {
      height: 100%;
      width: 382px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #fff;
      .rightItem {
        font-family: 'Helvetica';
        width: 100%;
        height: 74px;
        font-size: 36px;
        background: #00000020;
        line-height: 80px;
        box-sizing: border-box;
        padding: 0 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .rightItemzx {
        color: #4cffd2;
        width: 100%;
        height: 24px;
        background: #00000020;
        line-height: 24px;
        box-sizing: border-box;
        padding: 0 5px;
      }
    }
  }
}
</style>
